import { useEffect } from 'react';
import type { Paging } from './usePaging';

/**
 * When the list the screen shows says it is on a different page than the address asks for (a page
 * past the end came back as the last one), the address follows it (APP-135 §3, §7): quietly
 * (replace, no focus move, no scroll), once the person's saved size is known, and only from a
 * settled answer.
 *
 * `settled` is the page number of the answer on screen. Pass `undefined` while a placeholder is
 * held in place or nothing has loaded yet, so a half-known list never rewrites a good address.
 */
export function useClampedPage(
  paging: Pick<Paging, 'page' | 'ready' | 'setPage'>,
  settled: number | undefined,
): void {
  const { page, ready, setPage } = paging;
  useEffect(() => {
    if (ready && settled !== undefined && settled !== page) setPage(settled, { quiet: true });
  }, [page, ready, setPage, settled]);
}
